// 解析 IOMS 存储的 communicateType 格式 ("10-Gate password：xxx") 提取 vocCode
export const parseVocCode = (communicateType) => {
  if (!communicateType) return ''
  const raw = String(communicateType)
  const dashIdx = raw.indexOf('-')
  return dashIdx > -1 ? raw.substring(0, dashIdx) : raw
}

// 解析 communicateType 中的 remark 部分（剔除 "Gate password：" 前缀）
export const parseCommunicateRemark = (communicateType) => {
  if (!communicateType) return { gatePassword: '', remark: '' }
  const raw = String(communicateType)
  const dashIdx = raw.indexOf('-')
  if (dashIdx === -1) return { gatePassword: '', remark: '' }
  const remark = raw.substring(dashIdx + 1)
  if (remark.startsWith('Gate password：')) {
    return { gatePassword: remark.replace('Gate password：', ''), remark: '' }
  }
  return { gatePassword: '', remark }
}

// GE+ 产品,国际标快+包裹/文件
const GE_PLUS_LIST = ['C921', 'C919']

// 判断是否为GE+产品
export const isGEPlusFn = (code) => {
  return GE_PLUS_LIST.includes(code)
}

// 签收底单的类型
export const signedDeliveryReceipt = ['2', '5', '252']
// 派送证明的类型
export const proofOfDelivery = ['15']
// 签单返还的类型
export const signedReturn = ['71']
// 宅配延伸的类型
export const postAssembly = ['68']

export const deliveryTypeText = {
  '7': { en: 'Direct Delivery with Signature Confirmation', zh: '派送至收件人住址，当面签收' },
  '8': { en: 'Parcel Locker/Delivery Box Placement', zh: '请投递至宅配箱' },
  '9': { en: 'Leave at the secure location such as doorstep or entrance if the recipient is absent and no parcel locker is available', zh: '若收件人不在且无宅配箱，可放置于门口' },
  '10': { en: 'At the door', zh: '门口' },
  '11': { en: 'Security office', zh: '保安室' },
  '12': { en: 'Parcel Locker', zh: '无人快递柜' },
  '13': { en: 'Face-to-face delivery at recipient address', zh: '收件人地址当面配送' },
  '14': { en: 'Other', zh: '其他' },
}

// 派送方式枚举
export const deliveryType = {
  '7': 'serviceSupport.querySupport.waybills.deliveryPreferenceType1',
  '8': 'serviceSupport.querySupport.waybills.deliveryPreferenceType2',
  '9': 'serviceSupport.querySupport.waybills.deliveryPreferenceType3',
  '10': 'serviceSupport.querySupport.waybills.deliveryPreferenceType4',
  '11': 'serviceSupport.querySupport.waybills.deliveryPreferenceType5',
  '12': 'serviceSupport.querySupport.waybills.deliveryPreferenceType6',
  '13': 'serviceSupport.querySupport.waybills.deliveryPreferenceType7',
  '14': 'serviceSupport.querySupport.waybills.deliveryPreferenceType8',
}

export const result = {
  code: 0,
  result: [
    {
      barNewList: [
        {
          barScanDt: '2023-12-07',
          barScanTm: '18:14:44',
          opCode: '54',
          opName: null,
          remark: '顺丰速运 已收取快件',
          scanDate: '2023-12-07',
          stayWhyCode: null,
          opCodeStatus: 'pickedup',
        },
        {
          barScanDt: '2023-12-07',
          barScanTm: '18:14:56',
          opCode: '50',
          opName: null,
          remark: '顺丰速运 已收取快件',
          scanDate: '2023-12-07',
          stayWhyCode: null,
          opCodeStatus: 'collect',
        },
        {
          barScanDt: '2023-12-07',
          barScanTm: '18:17:52',
          opCode: '80',
          opName: null,
          remark:
            '您的快件已签收，如有疑问请电联快递员【罗晨晨，电话： 】，感谢您使用顺丰，期待再次为您服务。（主单总件数：1件）',
          scanDate: '2023-12-07',
          stayWhyCode: null,
          opCodeStatus: 'signed',
        },
        {
          barScanDt: '2023-12-07',
          barScanTm: '18:17:53',
          opCode: '8000',
          opName: null,
          remark: '在官网"运单资料&签收图"，可查看签收人信息',
          scanDate: '2023-12-07',
          stayWhyCode: '1',
          opCodeStatus: 'signed',
        },
      ],
      destCityName: '深圳市',
      destCountryCode: 'CN',
      productName: '顺丰国际标快+（包裹）',
      productCode: 'SE0153',
      cargoTypeCode: 'C921',
      sourceCityName: '深圳市',
      sourceCountryCode: 'CN',
      waybillNo: 'SF1620023127869',
      directives: null,
      addresseePostalCode: '1230841',
      deliverTime: null,
      sfDirect: false,
      pisDeliveryTm: null,
      timeZone: 'UTC+8',
    },
  ],
  message: '请求成功',
  detailMessage: null,
}
